import { FC, MutableRefObject } from 'react';

import { Formik, type FormikHelpers } from 'formik';
import SimpleLeadForm from 'modules/account/contact/forms/SimpleLeadForm';
import {
  SIMPLE_LEAD_FORM,
  LEAD_FORM,
  SIMPLE_LEAD_SCHEMA,
} from 'modules/account/contact/forms/schema';
import { useCreateLead } from 'modules/account/contact/hooks';

const FORM_INIT = {
  firstName: '',
  emailAddress: '',
};

type LeadProps = {
  close: (
    focusableElement?: HTMLElement | MutableRefObject<HTMLElement | null>,
  ) => void;
};

const Lead: FC<LeadProps> = ({ close }) => {
  const { mutate: addLead } = useCreateLead({ disableHide: true });

  const onSubmit = (
    values: SIMPLE_LEAD_FORM,
    { setSubmitting }: FormikHelpers<SIMPLE_LEAD_FORM>,
  ) => {
    addLead(values as LEAD_FORM, {
      onSuccess: () => {
        close();
      },
      onSettled: () => {
        setSubmitting(false);
      },
    });
  };

  return (
    <Formik
      initialValues={FORM_INIT}
      onSubmit={onSubmit}
      validationSchema={SIMPLE_LEAD_SCHEMA}
    >
      {() => <SimpleLeadForm onCancel={close} />}
    </Formik>
  );
};

export default Lead;
